module.exports = Roo.ConfigProvider;